import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream px-4 py-14" data-id="element-108" data-mp="1o3x23lbnuo1h">
      <div className="mx-auto max-w-2xl rounded-3xl border border-teal/25 bg-white p-7 text-center shadow-card sm:p-9" data-id="element-109" data-mp="1o33s8bhenif4">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-teal/10" data-id="element-110" data-mp="221bvt28y5hz9">
          <ShieldCheckIcon className="h-8 w-8 text-teal" data-id="element-111" data-mp="1x2im7kws6b4d" />
        </div>
        <h2 className="font-display text-2xl font-black text-navy sm:text-3xl" data-id="element-112" data-mp="19fahp576f63e">
          Garantía 7 días — sin preguntas
        </h2>
        <div className="mt-4 space-y-2 text-[15px] leading-relaxed text-navy/70" data-id="element-113" data-mp="1j4k88gmdggpe">
          <p data-id="element-114" data-mp="1j6n3pg6an21i">Abres los tomos. Los usas en el aula.</p>
          <p className="font-semibold text-navy" data-id="element-115" data-mp="1ecsp2r5jpd9a">
            Si el lunes no entras diferente, te devolvemos el 100%.
          </p>
          <p className="text-sm" data-id="element-116" data-mp="qmeyl52lzmgt">Sin formularios, sin drama.</p>
        </div>
        <p className="mt-5 inline-block rounded-full bg-teal/10 px-4 py-1.5 text-sm font-bold text-teal" data-id="element-117" data-mp="lodeqhxczj4a">
          Tasa de devoluciones: menos del 1%
        </p>
      </div>
    </section>;
}